module.exports = __webpack_public_path__ + "images/emoji/page_facing_up.33b90ac1c6aef63d0a71.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/page_facing_up.png
// module id = WfYi
// module chunks = 24